import React from "react";
import { features } from "../constants";

export default function FeatureSection() {
  return (
    <div className="relative mt-20 border-b border-neutral-800 min-h-[800px]" id="feature-section">
      <div className="text-center">
        <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-10 lg:mt-20 tracking-wide">
          :התמקדות באיכות ובמקצועיות <br />
          <span className="bg-gradient-to-r from-orange-500 to-orange-800 text-transparent bg-clip-text">
            נקודת המוצא לתכנון מערכות חשמליות מתקדמות
          </span>
        </h2>
      </div>
      <div className="flex flex-wrap mt-10 lg:mt-20">
        {features.map((feature, index) => (
          <div key={index} className="w-full sm:w-1/2 lg:w-1/3">
            <div className="flex">
              <div>
                <h5 className="mt-10 mb-6 text-xl text-right">{feature.text}</h5>
                <p className="text-md p-2 mb-10 text-neutral-500 text-right">
                  {feature.description}
                </p>
              </div>
              <div className="flex mx-6 h-10 w-10 p-2 bg-neutral-900 text-orange-700 justify-center items-center rounded-full">
                {feature.icon}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
